import { configureStore } from "@reduxjs/toolkit";
import complianceReducer from "./reducer/complianceReducer";
import fiuReducer from "./reducer/fiuReducer";
import transactionReducer from "./reducer/transactionReducer";
import kybOnboardingReducer from "./reducer/kybOnboardingReducer";
import commonReducer from "./reducer/commonReducer";
import adminRoleReducer from "./reducer/adminRoleReducer";
import ipLogsReducer from "./reducer/ipLogsReducer";
import otcReducer from "./reducer/otcReducer";
import eddReducer from "./reducer/eddReducer";
import authReducer from "./reducer/authReducer";
export const store = configureStore({
  reducer: {
    auth: authReducer,
    compliance: complianceReducer,
    fiu: fiuReducer,
    transaction: transactionReducer,
    kybOnboarding: kybOnboardingReducer,
    common: commonReducer,
    adminRole: adminRoleReducer,
    ipLogs: ipLogsReducer,
    otc: otcReducer,
    edd: eddReducer,
  },
});
